import { apiService } from "./service";

export { apiService };
